// component/Cart/VenueCartItemCard.jsx
import React, { useState } from 'react';
import "./VenueCartItemCard.css";

const VenueCartItemCard = ({
  eventId,
  eventname,
  data,
  serviceType,
  refreshCart,
  removeItem,
  onVenueSelect,
  selectedcartitem,
  refundVenueProvider,
  updateVenueCartItem,
  openRefundDialog,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isRefunding, setIsRefunding] = useState(false);

  const handleToggleSelect = (item, checked) => {
    onVenueSelect(eventId, serviceType, checked, {
      id: item.id,
      total: item.totalAmount || item.subtotal || 0,
      cartid: [{ cart_id: item.id, space_id: item.spaceId }],
    }, item.totalAmount || item.subtotal || 0);
  };

  const handleRefund = async (item) => {
    setIsRefunding(true);
    try {
      await refundVenueProvider(eventId, item.providerId);
      refreshCart();
    } catch (error) {
      console.error("Refund failed:", error);
    } finally {
      setIsRefunding(false);
    }
  };

  const isItemSelected = (item) => {
    const event = selectedcartitem.find(p => p.eventid === eventId);
    if (!event) return false;
    return event.services[serviceType]?.some(d => d.id === item.id) || false;
  };

  const getTotalPrice = (item) => {
    return parseFloat(item.totalAmount || item.subtotal || 0);
  };

  const formatCurrency = (amount) => {
    return `₹${Math.round(amount).toLocaleString()}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  return (
    <div className="venue-cart-item-card">
      {data.map((item) => {
        const isSelected = isItemSelected(item);
        const isCheckedOut = item.is_checked_out;

        return (
          <div key={item.id} className="venue-cart-item">
            <div className="venue-item-header">
              <div className="venue-selector">
                {!isCheckedOut && (
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={(e) => handleToggleSelect(item, e.target.checked)}
                    className="venue-checkbox"
                  />
                )}
                <span className="venue-name">{item.venue?.name || 'Venue'}</span>
              </div>
              <div className="venue-status-badge">
                {isCheckedOut ? (
                  <span className="badge checked-out">Checked Out</span>
                ) : (
                  <span className="badge in-cart">In Cart</span>
                )}
                {item.is_canceled && (
                  <span className="badge canceled">Canceled</span>
                )}
              </div>
            </div>

            <div className="venue-item-details">
              <div className="venue-detail-row">
                <span className="detail-label">Section:</span>
                <span className="detail-value">{item.section?.name || 'N/A'}</span>
              </div>
              <div className="venue-detail-row">
                <span className="detail-label">Guests:</span>
                <span className="detail-value">{item.no_of_guests || item.guest_count || 'N/A'}</span>
              </div>
              <div className="venue-detail-row">
                <span className="detail-label">Dates:</span>
                <span className="detail-value">
                  {formatDate(item.from_date || item.fromDate)} - {formatDate(item.to_date || item.toDate)}
                </span>
              </div>
              <div className="venue-detail-row">
                <span className="detail-label">Timing:</span>
                <span className="detail-value">
                  {item.from_time || item.start_time || 'N/A'} - {item.to_time || item.end_time || 'N/A'}
                </span>
              </div>
              <div className="venue-detail-row">
                <span className="detail-label">Pricing Type:</span>
                <span className="detail-value">{item.pricing_type || item.pricingType || 'N/A'}</span>
              </div>
              {item.food_included && (
                <div className="venue-detail-row">
                  <span className="detail-label">Food:</span>
                  <span className="detail-value food-included">Included</span>
                </div>
              )}
              {item.foodSelections?.length > 0 && (
                <div className="venue-food-selections">
                  <span className="detail-label">Menu Selections:</span>
                  <div className="food-items">
                    {item.foodSelections.map((food, idx) => (
                      <span key={idx} className="food-item">
                        {food.menuName || `Menu ${food.menuId}`} ({food.guestCount} guests)
                      </span>
                    ))}
                  </div>
                </div>
              )}
              {item.drinkSelections?.length > 0 && (
                <div className="venue-drink-selections">
                  <span className="detail-label">Drink Selections:</span>
                  <div className="drink-items">
                    {item.drinkSelections.map((drink, idx) => (
                      <span key={idx} className="drink-item">
                        {drink.drinkName || `Drink ${drink.drinkOptionId}`} ({drink.guestCount} guests)
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="venue-item-pricing">
              <div className="price-breakdown">
                <div className="price-row">
                  <span>Subtotal:</span>
                  <span>{formatCurrency(item.subtotal || 0)}</span>
                </div>
                {item.gst_amount > 0 && (
                  <div className="price-row">
                    <span>GST ({item.gst_percentage || 18}%):</span>
                    <span>{formatCurrency(item.gst_amount || 0)}</span>
                  </div>
                )}
                <div className="price-row total">
                  <span>Total:</span>
                  <span>{formatCurrency(item.totalAmount || item.subtotal || 0)}</span>
                </div>
                {item.paid_amount > 0 && (
                  <div className="price-row paid">
                    <span>Paid:</span>
                    <span>{formatCurrency(item.paid_amount)}</span>
                  </div>
                )}
                {item.balance_to_be_paid > 0 && (
                  <div className="price-row balance">
                    <span>Balance:</span>
                    <span>{formatCurrency(item.balance_to_be_paid)}</span>
                  </div>
                )}
              </div>
            </div>

            <div className="venue-item-actions">
              {!isCheckedOut && !item.is_canceled && (
                <>
                  {item.is_edit_allowed && (
                    <button
                      className="action-btn edit-btn"
                      onClick={() => {
                        // Open edit modal
                        console.log("Edit venue item:", item.id);
                      }}
                    >
                      Edit
                    </button>
                  )}
                  <button
                    className="action-btn refund-btn"
                    onClick={() => handleRefund(item)}
                    disabled={isRefunding}
                  >
                    {isRefunding ? 'Processing...' : 'Refund'}
                  </button>
                  <button
                    className="action-btn remove-btn"
                    onClick={() => removeItem(item.id)}
                  >
                    Remove
                  </button>
                </>
              )}
              {item.is_canceled && (
                <span className="canceled-label">This booking has been canceled</span>
              )}
              {isCheckedOut && !item.is_canceled && (
                <span className="checked-out-label">This booking has been checked out</span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default VenueCartItemCard;